import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

export default function ResendOtp({ onClick, disabled, seconds, exhausted = false }) {
  const { theme } = useTheme();
  const isDark = theme.auth.containerBg === '#111827';
  const isDisabled = disabled || exhausted;
  const label = exhausted ? 'No more resends' : disabled ? `Resend OTP in ${seconds}s` : 'Resend OTP';
  
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      style={{
        marginTop: 4,
        width: '100%',
        padding: '9px 12px',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: '0.2px',
        backgroundColor: 'transparent',
        color: isDisabled ? theme.auth.mutedText : (isDark ? '#2dd4bf' : '#0f766e'),
        border: `2px solid ${isDisabled ? (isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.09)') : (isDark ? 'rgba(13, 148, 136, 0.4)' : 'rgba(15, 118, 110, 0.3)')}`,
        borderRadius: 10,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        opacity: isDisabled ? 0.6 : 1,
      }}
      onMouseEnter={(e) => !isDisabled && (e.target.style.borderColor = isDark ? 'rgba(13, 148, 136, 0.6)' : 'rgba(15, 118, 110, 0.5)', e.target.style.color = isDark ? '#5eead4' : '#14b8a6', e.target.style.background = isDark ? 'rgba(13, 148, 136, 0.05)' : 'rgba(15, 118, 110, 0.05)')}
      onMouseLeave={(e) => !isDisabled && (e.target.style.borderColor = isDark ? 'rgba(13, 148, 136, 0.4)' : 'rgba(15, 118, 110, 0.3)', e.target.style.color = isDark ? '#2dd4bf' : '#0f766e', e.target.style.background = 'transparent')}
    >
      {label}
    </button>
  );
}
